module.exports = __webpack_public_path__ + "static/media/Performance-Tracking-image.7771a7a8.png";